import { BrawlerStats } from "../domine/brawler-stats.types";
import { getDoubleValue, getIntegerValue, getStringValue, getTimestamp } from "../firestore/firestore.functions";
import { HttpFirestoreDocument } from "../firestore/firestore.types";
import { ModeAndTeam, HttpFirestoreMode, Mode, ModeStats, ALL_ID } from "./mode-stats.types";

const COLLECTION_MODE = "mode"
const DOCUMENT_MODE_PREFIX = "mode-"

export const getModeStats = async (mode: ModeAndTeam): Promise<ModeStats> => {
  const modeStats = await getModeStatsFromFirestoreHttp(mode)
  return modeStats
};

const getModeStatsFromFirestoreHttp = async (mode: ModeAndTeam): Promise<ModeStats> => {
  const modeId = modeToUrlMode(mode.mode)
  const teamId = mode.teamComposition === ALL_ID ? "" : `--${modeToUrlMode(mode.teamComposition)}`
  try {
    const modeResponse = await fetch(`https://firestore.googleapis.com/v1/projects/topbrawl-d96ec/databases/(default)/documents/${COLLECTION_MODE}/${DOCUMENT_MODE_PREFIX}${modeId}${teamId}?key=AIzaSyAHrKlPV1fy5MMksth6i89FcsNf8ZN-yao`);
    const modeJson = await modeResponse.json();
    const modeTyped = modeJson as HttpFirestoreDocument<HttpFirestoreMode>;
    const mode = convertHttpFirestoreModeToMode(modeTyped)
    return mode
  } catch (error) {
    throw new Error(`${error}: ${modeId}`);
  }
};

const convertHttpFirestoreModeToMode = (firestoreModeStats: HttpFirestoreDocument<HttpFirestoreMode>): ModeStats => {
  const fields = firestoreModeStats.fields;
  const brawlersStats: BrawlerStats[] = fields.mode.mapValue.fields.brawlersStats.arrayValue.values.map(value => {
    const stats = value.mapValue.fields;
    return {
      brawlerId: getIntegerValue(stats.brawlerId)!,
      brawlerName: getStringValue(stats.brawlerName)!,
      wins: getIntegerValue(stats.wins)!,
      loses: getIntegerValue(stats.loses)!,
      totalBattles: getIntegerValue(stats.totalBattles)!,
      winRate: getDoubleValue(stats.winRate),
      useRate: getDoubleValue(stats.useRate),
      effectivityRate: getDoubleValue(stats.effectivityRate),
    };
  });
  const modeFields = fields.mode.mapValue.fields
  const mode: Mode = {
    lastUpdate: getTimestamp(modeFields.lastUpdate),
    mode: getStringValue(modeFields.mode),
    teamComposition: getStringValue(modeFields.teamComposition),
    brawlersStats: brawlersStats,
  };
  const currentModes: ModeAndTeam[] = fields.currentModes.arrayValue.values.map(value => {
    const mode = value.mapValue.fields;
    return {
      mode: getStringValue(mode.mode)!,
      teamComposition: getStringValue(mode.teamComposition)!
    };
  });
  const modeStats: ModeStats = {
    currentModes: currentModes,
    mode: mode
  };
  return modeStats;
};

export const modeToUrlMode = (mode: String) => mode.toLowerCase().replace(/_/g, "-")
export const modeUrlToMode = (mode: String) => mode.toUpperCase().replace(/-/g, "_")